export enum EUserType {
    ROOT = 'ROOT',
    ADMIN = 'ADMIN',
    MANAGER = 'MANAGER',
    OPERATOR = 'OPERATOR',
    USER = 'USER',
    // COURSE_CREATOR = 'COURSE_CREATOR',
    // TRAINER = 'TRAINER',
    SPONSOR = 'SPONSOR',
    STUDENT_TRAINER_CC = 'STUDENT_TRAINER_CC',
}
